import { common } from './common.icons';

export const IconArrowRightThin = ({ className = '', style = {}, ...rest }: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={`icon-arrow-right-thin ${common.classes} ${className}`}
      {...rest}
      style={{ ...common.styles, ...style }}
      viewBox="0 0 12 9"
      strokeWidth="2"
      stroke="currentColor"
      fill="none"
      strokeLinecap="round"
    >
      <path d="M1 4.5004H10.3344M5.6672 8.0008L10.3344 4.5004L5.6672 1" />
    </svg>
  );
};
